export function trigger() {
  const navTrigger = document.querySelector('.trigger-nav');
  const header = document.querySelector('.header');
  if (navTrigger) {
    navTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (document.body.classList.contains('is-nav-active')) {
        document.body.classList.remove('is-nav-active', 'is-search-active');
      } else {
        document.body.classList.remove('is-search-active');
        document.body.classList.add('is-nav-active');
      }
    })
  }
  const inputSearch = document.querySelector('.input-search');
  const navSearch = document.querySelector('.trigger-search');
  if (navSearch) {
    navSearch.addEventListener('click', (e) => {
      e.preventDefault();
      if(header) header.style.height = '';
      if (document.body.classList.contains('is-search-active')) {
        document.body.classList.remove('is-search-active', 'is-nav-active');
        if(inputSearch) inputSearch.blur();
      } else {
        document.body.classList.remove('is-nav-active');
        document.body.classList.add('is-search-active');
        if(inputSearch) inputSearch.focus();
      }
    })
  }
  const handleReset = () => {
    document.body.classList.remove('is-search-active', 'is-nav-active');
    if(header) header.style.height = '';
  }
  const navReset = document.querySelector('.trigger-reset');
  if (navReset) {
    navReset.addEventListener('click', (e) => {
      e.preventDefault();
      handleReset();
    })
  }
  
  const navParents = document.querySelectorAll('.nav-parent');
  navParents.forEach((el) => {
    if(hasTouchScreen()) {
      const trigger = el.querySelector('.nav-parent-trigger');
      if(trigger) {
        trigger.addEventListener('touchstart', (e) => {
          e.preventDefault();
          if(el.classList.contains('is-active')) {
            el.classList.remove('is-active')
          } else {
            el.classList.add('is-active')
          }
        });
      }
    } else {
      el.addEventListener('mouseenter', (e) => {
        el.classList.add('is-active')
      });
      el.addEventListener('mouseleave', (e) => {
        el.classList.remove('is-active')
      });
    }
  });
  let lastInnerWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    if (lastInnerWidth !== window.innerWidth) {
      lastInnerWidth = window.innerWidth;
      handleReset();
    }
  });
}